import type { CSSProperties } from 'react';

export interface DealSpotLogoProps {
  variant?: 'header' | 'footer' | 'sidebar';
  className?: string;
  style?: CSSProperties;
}

/**
 * DealSpotLogo — placeholder único trocável da marca.
 *
 * Asset SVG final pendente — quando chegar, substituir o <span> abaixo por
 * <img src=... /> em UM único lugar. Este componente é o único ponto de troca
 * da identidade visual; consumers o usam diretamente, sem hardcoded "DealSpot"
 * espalhado pela UI.
 */
export function DealSpotLogo({ variant = 'header', className, style }: DealSpotLogoProps) {
  const baseClass = variant === 'sidebar' ? 'text-lg' : 'text-xl';
  return (
    <span
      className={`font-bold text-gray-900 ${baseClass}${className ? ` ${className}` : ''}`}
      style={style}
      aria-label="DealSpot"
      data-variant={variant}
    >
      DealSpot
    </span>
  );
}
